import { ref } from 'vue'

export function useInstruction() {
  const isOpenInstruction = ref(false)

  /**
   * Toggle instruction modal
   */
  const toggleInstruction = (): void => {
    isOpenInstruction.value = !isOpenInstruction.value
  }

  return {
    isOpenInstruction,
    toggleInstruction,
  }
}
